<template>
    <v-dialog v-model="getDirectionViewer" width="40%" height="350" @click:outside="closePopup()">
        <v-card class="directionalDialog text-center">
            <v-card-title class="text-h2 pa-0">
                <v-row no-gutters>
                    <v-col cols="1"></v-col>
                    <v-col cols="10" class="mt-6"> Clerk's Office</v-col>
                    <v-col cols="1" class="pr-3"> <v-icon color="red" size="50"
                            @click="closePopup()">mdi-close-circle-outline</v-icon></v-col>
                </v-row>
                <!-- <v-btn @click="closePopup()" class="my-4">Close</v-btn> -->
            </v-card-title>
            <v-card-title class="text-h4 d-flex justify-center pb-0">Civil - Criminal - Passport - Real Estate</v-card-title>

            <lottie :options="lottieOptions" :height="400" :width="400" />
        </v-card>
    </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex';
import arrow1 from "@/assets/arrow.json"
export default {
    name: "directionViewer",
    computed: {
        ...mapGetters(["getDirectionViewer", "getTouchCount", "getSessionId", "getGreetingStatus", "getKioskProfile"])
    },
    data() {
        return {
            lottieOptions: {
                animationData: arrow1,
                loop: true,
                autoplay: true
            },
        }
    },
    methods: {
        closePopup() {
            let date = new Date()
            this.$store.commit('setTouchCount', this.getTouchCount + 1)
            if (this.getTouchCount === 1 && !this.getGreetingStatus) {
                // start time
                //session start object
                this.$store.dispatch('addUserSessionToStrapi', {
                    applicationId: this.getKioskProfile.data().applicationId,
                    actionType: 'Session Start',
                    applicationSessionId: this.getSessionId,
                    timeStamp: date.toISOString(),
                    sessionPayload: {
                        module: "Default",
                        action: "Touch Detected",
                        response: "User Session Started",
                        timeStamp: date.toISOString()
                    }
                })
                this.$store.dispatch('addInteractionToPostgres', { actionType: 'Session Started', actionPayload: { recognitionType: 'Touch' } })
            }
            this.$store.dispatch('addUserSessionToStrapi', {
                applicationId: this.getKioskProfile.data().applicationId,
                actionType: 'Touch',
                applicationSessionId: this.getSessionId,
                timeStamp: date.toISOString(),
                sessionPayload: {
                    module: "Home Page",
                    action: "Touch",
                    response: "Close Popup",
                    timeStamp: date.toISOString()
                }
            })
            this.$store.dispatch("resetKiosk");
            this.$store.commit("setDirectionViewer", false)
        }
    }
}
</script>
<style scoped>
.directionalDialog {
    border-radius: 20px !important;
}
</style>